import { render } from "./AuthPanel.vue?vue&type=template&id=4b506d8c&scoped=true"
import script from "./AuthPanel.vue?vue&type=script&lang=js"
export * from "./AuthPanel.vue?vue&type=script&lang=js"

import "./AuthPanel.vue?vue&type=style&index=0&id=4b506d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b506d8c"]])

export default __exports__